<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
	</div>
</template>

<script>

export default {
	name: 'mimdgcategoriaestiba-grid',
	components: {
	},
	data() {
		return {
			modelName: 'mimdgcategoriaestiba',
			modelColumnDefs: {
			}
		}
	}
}
</script>
